import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-job-match-compare-modal',
  templateUrl: './job-match-compare-modal.component.html'
})
export class JobMatchCompareModalComponent implements OnInit {

  modalData: any;
  label: any;

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService
  ) {
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() {
    this.label = this.modalData.label;
  }

  closeModal() {
    this.bsModalRef.hide();
  }
}
